export const FETCH_USER_FORM = 'PERSONAL_DATA:FETCH_USER_FORM';
export const FETCH_USER_FORM_SUCCESS = 'PERSONAL_DATA:FETCH_USER_FORM_SUCCESS';
export const FETCH_USER_FORM_ERROR = 'PERSONAL_DATA:FETCH_USER_FORM_ERROR';

export const SAVE_USER_FORM = 'PERSONAL_DATA:SAVE_USER_FORM';
export const SAVE_USER_FORM_SUCCESS = 'PERSONAL_DATA:SAVE_USER_FORM_SUCCESS';
export const SAVE_USER_FORM_ERROR = 'PERSONAL_DATA:SAVE_USER_FORM_ERROR';

export const UPDATE_USER_FORM_FIELD = 'PERSONAL_DATA:UPDATE_USER_FORM_FIELD';

export const RESET_ERROR = 'PERSONAL_DATA:RESET_ERROR';
